import HttpService from '@/common/services/HttpService'
import { SkillsIncludeEnum, type SkillDTOV2 } from '@/common/types/skills'
import localizationServerData from '@/common/services/serverData/localizationServerData'
import { PrefixTranslationsEnum } from '@/common/types/i18n'

const ServicePathV2 = '/api/v2/skills'

interface SkillByCodeServiceParams {
  skillCode: string
}

export const getSkillByCode = ({ skillCode }: SkillByCodeServiceParams) => {
  return HttpService.getData<SkillDTOV2>(`${ServicePathV2}/${skillCode}`)
}

export const getSkillsV2 = async (): Promise<SkillDTOV2[]> => {
  return HttpService.getData<SkillDTOV2[]>(ServicePathV2, {
    params: {
      'include-deactivated': true,
      include: SkillsIncludeEnum.PRODUCTIVITY,
    },
  })
}

export const fetchTargetSkillsForTransferV2 = async (code: string): Promise<SkillDTOV2[]> => {
  const [skills] = await Promise.all([
    HttpService.getData<SkillDTOV2[]>(`${ServicePathV2}/${code}/target-skills-for-transfer`),
    localizationServerData.fetch({
      prefixes: [PrefixTranslationsEnum.SPACE, PrefixTranslationsEnum.SKILL],
    }),
  ])
  return skills
}
